<template lang="html">
  <div>
    <div class="subnav">
      <div class="has-text-centered">
          <a href="#" v-scroll-to="'#docs'" class="is-uppercase">Documentation</a>
          <span class="plr-1 separator">|</span>
          <a href="#" v-scroll-to="'#faq'" class="is-uppercase">FAQ</a>
          <span class="plr-1 separator">|</span>
          <a href="#" v-scroll-to="'#feedback'" class="is-uppercase">Feedback</a>
      </div>
    </div>

    <section class="section appOdd" id="soup">
      <div class="container has-text-centered">
        <h1 class="title is-size-1-desktop is-size-1-tablet is-size-2-mobile">Soup</h1>
        <h2 class="subtitle">Granular audio fluid</h2>
        <figure class="image is-5by3">
          <img src="@/assets/img/soup.jpg">
        </figure>
      </div>

      <div class="container">
        <div class="columns">

          <div class="column">
            <div class="content">
              <h1 class="title">Retro Future</h1>
              <p>Inspired by the oil can delays of the 60s and our previous granular explorations, Curtis and Spunk, Soup brings you a virtual fluid that you can record onto, slosh around, and play back from. You can use it as a unique delay effect or more like a granular synthesizer, concocting your own wholly novel sounds.</p>
            </div>
          </div>

          <div class="column">
            <div class="content">
              <h1 class="title">Quantum Sound</h1>
              <p>Soup breaks up recordings into individual sound quanta with which you can interact as if they made up an audio fluid. They can be played linearly or randomly, forward, backward, or even sideways. They can, moreover, be stirred together, giving a whole new meaning to mixing sound.</p>
            </div>
          </div>

        </div>

      </div>

      <div class="container">
        <div class="columns">

          <div class="column">
            <div class="content">
              <h1 class="title">Audio Palette</h1>
              <p>Soup will let you literally paint with sound. You can record external sounds through the microphone or import WAV files, slathering sound over the virtual fluid. Then your fingers can become play heads, reading back the sounds from any position, or multiple positions at once.</p>
            </div>
          </div>

          <div class="column">
            <div class="content">
              <a class="button is-link" href="https://vimeo.com/267080156">
                <span class="icon">
                  <i class="fab fa-vimeo"></i>
                </span>
                <span>Watch Video</span>
              </a>

              <a class="button is-link" href="https://itunes.apple.com/us/app/soup-granular/id1358214341?ls=1&mt=8">
                <span class="icon">
                  <i class="fab fa-app-store"></i>
                </span>
                <span>Download for iPad</span>
              </a>

              <a href="#" v-scroll-to="'#docs'" class="button is-link">
                <span class="icon">
                  <i class="far fa-file-alt"></i>
                </span>
                <span>Docs</span>
              </a>

              <figure class="">
                <a href="https://itunes.apple.com/us/app/soup-granular/id1358214341?ls=1&mt=8">
                  <img src="@/assets/img/app-store.svg" width="256">
                </a>
              </figure>

            </div>
          </div>

        </div>

        <div class="container">
          <div class="columns">

            <div class="column">
              <div class="content">
                <a class="button is-primary" href="#" v-scroll-to="'#top'">
                  <span class="icon">
                    <i class="fas fa-arrow-up"></i>
                  </span>
                  <span>Back to top</span>
                </a>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>

    <section class="section hero is-light" id="docs">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-2 is-size-3-mobile">
            Documentation
          </h1>
          <h2 class="subtitle">
          </h2>
        </div>
        <div class="hero-foot">
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h1 class="title">Fluid Concept</h1>
        <p>Sound flows into the app and gets recorded onto the particle fluid at the write head (red circle) position. Sound gets played back from the fluid from the read head (green circle) position.</p>
      </div>
    </section>

    <section v-if="docs && docs.length">
      <div class="container" v-for="doc of docs" :key="doc.id">
        <div class="columns">

          <div class="column">
            <div class="content">
              <figure class="">
                <img :src="doc.image" width="256">
              </figure>
            </div>
          </div>

          <div class="column">
            <div class="content">
              <h1 class="title">{{ doc.title }}</h1>
              <p>{{ doc.body }}</p>
              <p>{{ doc.more }}</p>
            </div>
          </div>
        </div>

      </div>

      <div class="container">
        <div class="columns">

          <div class="column">
            <div class="content">
              <a class="button is-primary" href="#" v-scroll-to="'#top'">
                <span class="icon">
                  <i class="fas fa-arrow-up"></i>
                </span>
                <span>Back to top</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="section hero is-light" id="faq">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-2 is-size-3-mobile">
            FAQ
          </h1>
          <h2 class="subtitle">
          </h2>
        </div>
        <div class="hero-foot">
        </div>
      </div>
    </section>

    <section>
      <div class="faq">
        <div class="container">
          <section class="section">
            <div class="columns is-multiline" v-if="faqs && faqs.length">
              <div class="column is-one-third" v-for="faq of faqs" :key="faq.id">
                <div class="card">
                  <div class="card-content">
                    <p class="title">{{ faq.title }}</p>
                    <p class="answer">{{ faq.body }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="container">
          <div class="columns">

            <div class="column">
              <div class="content">
                <a class="button is-primary" href="#" v-scroll-to="'#top'">
                  <span class="icon">
                    <i class="fas fa-arrow-up"></i>
                  </span>
                  <span>Back to top</span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section class="section hero is-light" id="feedback">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-size-2 is-size-3-mobile">
            Feedback
          </h1>
          <h2 class="subtitle">
          </h2>
        </div>
        <div class="hero-foot">
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="comments">
          <vue-disqus title="Soup" shortname="strange-software" identifier="strange-software-ipad-soup" url="http://strange.software/ipad/soup"></vue-disqus>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

import Fluid from '@/assets/img/docs/fluid.gif'
import Input from '@/assets/img/docs/input.gif'
import Modes from '@/assets/img/docs/modes.gif'
import Output from '@/assets/img/docs/output.gif'
import Read from '@/assets/img/docs/read.gif'
import Write from '@/assets/img/docs/write.gif'

import VueDisqus from 'vue-disqus/VueDisqus.vue'

export default {
  components: {
    VueDisqus
  },
  name: 'Soup',
  data: () => ({
    docs: [
      {
        'title': 'Modes',
        'body': 'The buttons below the fluid determine what touching the fluid will do. The top row lets you control the WRITE head, the READ head, or simply stir the fluid with touch. Below the WRITE and READ buttons are the touch mode toggles, making the respective head always ON, or in TOUCH mode, only on when the fluid is touched. Multitouch is available in TOUCH mode and when using STIR.',
        'image': Modes
      },
      {
        'title': 'Input',
        'body': 'Here you can change the level of the two input sources. The MIC / LINE source is your iPad’s microphone or line input. Be aware that if the iPad is playing back loudly, particularly through external speakers, the mic can pick up and record this sound. Of course the resultant delayed feedback can be fun to experiment with.',
        'more': 'The FILE source is a file player that can be used to play back your own samples. You can add WAV files via iTunes or you can open WAV files from other apps like Dropbox or the iOS Files app.',
        'image': Input
      },
      {
        'title': 'Ouput',
        'body': 'Here you can control overall output VOLUME as well as the level of the DRY MIX. The latter controls how much INPUT sound is mixed in with the output. If you want to go completely dry, turn down the GAIN in the READ section.',
        'more': 'The leftmost button lets you record app output and the next button allows you to save it. The third button lets you share recordings with other apps.',
        'image': Output
      },
      {
        'title': 'Write',
        'body': 'The GAIN fader controls the level with which input sound is written to the fluid. RADIUS controls the size of the write head. DENSITY will let you write to all or just some of the particles within the writing radius. SIZE controls the size of the audio grains being written.',
        'image': Write
      },
      {
        'title': 'Read',
        'body': 'The read GAIN fader controls the volume at which particles are being read. As on the writing side, RADIUS controls the size of the read head and DENSITY the number of particles being read. DECAY will gradually fade out particles as they are read, effectively quieting the fluid as it is being played.',
        'more': 'Note that high RADIUS and DENSITY settings will make lesser iPads tremble and glitch will result.',
        'image': Read
      },
      {
        'title': 'Fluid',
        'body': 'The SPIN fader controls the tendency of the fluid to spin, either toward the right or toward the left. Note that the effect of this is initially subtle, for the fluid’s inertia must be overcome. DENSITY controls the number of particles in the fluid simulation. RADIUS constrains the fluid area.',
        'more': 'Note that high DENSITY or a very constrained RADIUS will use a lot of CPU, and you may start to hear glitches on lesser iPads.',
        'image': Fluid
      }
    ],
    faqs: [
      {
        'title': 'Will you be adding Audiobus or IAA?',
        'body': 'For now the answer is "sorry, probably not".'
      },
      {
        'title': 'Why not?',
        'body': 'Soup was conceived as a standalone app and, between the fluid simulation and the granular synth, it uses just about 100% of the CPU on most iPads.'
      },
      {
        'title': 'Can Soup share files?',
        'body': 'Yes indeed. You can easily open WAV files from the Files app, Dropbox, etc., and you can share Soup recordings as well.'
      }
    ]
  })
}

</script>



// WEBPACK FOOTER //
// src/components/Soup.vue